import { MYDRA_WORKSPACE_ID_HEADER_NAME } from '@/config/system'
import { PlaybooksService } from '@/services/playbook'
import { useWorkspaceContext } from '@/shared/hooks/useWorkspaceContext'
import { ApiErrorResponse, ApiIndividualResponse } from '@/types/api'
import { IPlaybookMessage } from '@/types/playbook.old'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

interface UsePlaybookMessagesOptions {
  id: string
  queryOptions?: Omit<
    UseQueryOptions<
      ApiIndividualResponse<IPlaybookMessage[]>,
      ApiErrorResponse,
      ApiIndividualResponse<IPlaybookMessage[]>
    >,
    'queryKey' | 'queryFn'
  >
}

export const usePlaybookMessages = ({
  id,
  queryOptions = {},
}: UsePlaybookMessagesOptions) => {
  const { workspaceId } = useWorkspaceContext()

  return useQuery({
    queryKey: [
      'playbook-messages',
      id,
      ...(workspaceId ? ['workspaceId', workspaceId] : []),
    ],
    queryFn: () =>
      PlaybooksService.getPlaybookMessages(id, {
        headers: {
          [MYDRA_WORKSPACE_ID_HEADER_NAME]: workspaceId,
        },
      }),
    ...queryOptions,
  })
}
